/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegionModel } from '../../models/region-model';
import { RegionUpdateModel } from '../../models/region-update-model';

export interface PutApiRegionV1Id$Plain$Params {

/**
 * Region Id
 */
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
  
    /**
     * Region model
     */
    body?: RegionUpdateModel
}

export function putApiRegionV1Id$Plain(http: HttpClient, rootUrl: string, params: PutApiRegionV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<RegionModel>> {
  const rb = new RequestBuilder(rootUrl, putApiRegionV1Id$Plain.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RegionModel>;
    })
  );
}

putApiRegionV1Id$Plain.PATH = '/private/v1/regions/{id}';
